var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCirclePlayIcon = function SvgCirclePlayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 44 44",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    stroke: "#fff",
    strokeWidth: 1.5,
    d: "M43.25 22c0 11.736-9.514 21.25-21.25 21.25S.75 33.736.75 22 10.264.75 22 .75 43.25 10.264 43.25 22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.5,
    d: "M43.25 22c0 11.736-9.514 21.25-21.25 21.25S.75 33.736.75 22 10.264.75 22 .75 43.25 10.264 43.25 22Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16.317 10.933a.86.86 0 0 1 .877.032l16.041 10.312a.86.86 0 0 1 0 1.446L17.194 33.035a.86.86 0 0 1-1.324-.722V11.686a.86.86 0 0 1 .447-.754",
    clipRule: "evenodd"
  })));
};
export default SvgCirclePlayIcon;